import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useGame } from "../../store/game";
import { useHaptic } from "../../hooks/useHaptic";
import styles from "../BurgerMenu.module.css"; 

type Referral = {
  id: number;
  firstName: string;
  username?: string;
  createdAt: string;
};

export function FrensModal() {
  const activeModal = useGame((s) => s.activeModal);
  const closeModal = useGame((s) => s.closeModal);
  const haptic = useHaptic();

  const [referrals, setReferrals] = useState<Referral[]>([]);
  const [count, setCount] = useState(0);

  const open = activeModal === "frens";
  const close = () => { if (activeModal === "frens") closeModal(); };

  useEffect(() => {
    if (open) {
      fetchReferrals();
    }
  }, [open]);

  const fetchReferrals = async () => {
    try {
      const tgInitData = window.Telegram?.WebApp?.initData || "mock";
      const apiUrl = import.meta.env.VITE_API_URL || "";
      const res = await fetch(`${apiUrl}/api/referrals`, {
        headers: { Authorization: `tma ${tgInitData}` }
      });
      if (res.ok) {
        const data = await res.json();
        setReferrals(data.referrals);
        setCount(data.count);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const copyInviteLink = () => {
    haptic.impact("medium");
    const initData = window.Telegram?.WebApp?.initDataUnsafe;
    const myId = initData?.user?.id || 123456789;
    
    // In a real app the bot name comes from env
    const inviteLink = `https://t.me/updown_btc_bot?startapp=ref_${myId}`;
    
    // Fallback to clipboard
    navigator.clipboard.writeText(`Play Up/Down BTC and get an Airdrop! ${inviteLink}`);
    
    // If inside tg, open share modal
    if (window.Telegram?.WebApp?.openTelegramLink) {
       window.Telegram.WebApp.openTelegramLink?.(
         `https://t.me/share/url?url=${encodeURIComponent(inviteLink)}&text=${encodeURIComponent("Play Up/Down BTC and get an Airdrop!")}`
       );
    } else {
       alert("Link copied!");
    }
  };

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            className={styles.backdrop}
            onClick={close}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.18 }}
          />
          <motion.div
            className={styles.sheet}
            style={{ height: "85vh" }}
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", stiffness: 320, damping: 36 }}
            drag="y"
            dragConstraints={{ top: 0, bottom: 0 }}
            dragElastic={{ top: 0, bottom: 0.4 }}
            onDragEnd={(_, info) => {
              if (info.offset.y > 100 || info.velocity.y > 500) close();
            }}
          >
            <span className={styles.handle} />
            <h2 className={styles.title}>{count} Frens</h2>
            
            <p style={{ textAlign: "center", color: "var(--fg-muted)", marginBottom: "1rem" }}>
              Invite friends to get +1000 GT each!
            </p>

            <button 
              onClick={copyInviteLink}
              style={{
                display: "block",
                width: "90%",
                margin: "0 auto 1.5rem",
                padding: "1rem",
                borderRadius: "12px",
                background: "var(--accent-blue)",
                color: "#fff",
                fontWeight: "bold",
                border: "none",
                fontSize: "1rem"
              }}
            >
              Invite a Fren
            </button>

            <div className={styles.list}>
              {referrals.length === 0 ? (
                <p style={{textAlign: "center", color: "#666", padding: "2rem"}}>No friends invited yet.</p>
              ) : (
                referrals.map((user) => (
                  <button
                    key={user.id}
                    type="button"
                    className={styles.item}
                    style={{ pointerEvents: "none" }}
                  >
                    <span className={styles.icon}>👤</span>
                    <span className={styles.body}>
                      <span className={styles.label}>{user.firstName} {user.username ? `(@${user.username})` : ''}</span>
                    </span>
                    <span className={styles.gtCounter}>+1000 GT</span>
                  </button>
                ))
              )}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
